








import Vue from 'vue';
import store from '../store';

import FilteredContent from '@/components/FilteredContent.vue';
import RamblingsFilters from '@/components/RamblingsFilters.vue';

export default Vue.extend({
	name      : 'Ramblings',
	components: {
		FilteredContent,
		RamblingsFilters,
	},
	beforeRouteEnter(to, from, next) {
		store.dispatch('changeFilterOptions', {
			numberOfParagraphs: Number(to.params.numberOfParagraphs),
			sentencesPerParagraph: Number(to.params.sentencesPerParagraph),
			wordsPerSentence: Number(to.params.wordsPerSentence),
			minWordLength: Number(to.params.minWordLength),
		})
			.then(() => {
				store.dispatch('makeRamblings')
					.then(() => {
						next();
					})
					.catch((error) => {
						next(error);
					});
			})
			.catch((error) => {
				next(error);
			});
	},
	beforeRouteUpdate(to, from, next) {
		store.dispatch('changeFilterOptions', {
			numberOfParagraphs: Number(to.params.numberOfParagraphs),
			sentencesPerParagraph: Number(to.params.sentencesPerParagraph),
			wordsPerSentence: Number(to.params.wordsPerSentence),
			minWordLength: Number(to.params.minWordLength),
		})
			.then(() => {
				store.dispatch('makeRamblings')
					.then(() => {
						next();
					})
					.catch((error) => {
						next(error);
					});
			})
			.catch((error) => {
				next(error);
			});
	},
});
